import { useEffect } from 'react';

import { useIsFocused } from '@react-navigation/native';

import { useLobbySectionSelection } from '@/feature/lobby/hooks/use-lobby-section-selection';
import { useEventsTabsStore } from '@/hooks/use-events-tabs-store';
import { navigate } from '@/navigation/navigation';
import { League } from '@/types/api.generated';

// time for the lobby to switch league before the sheet covers and freezes it
const LOBBY_SETTLE_MS = 500;

/** Opens the event sheet for "View full event", after the lobby has switched league underneath. */
export const useOpenPendingEventSheet = () => {
    const isFocused = useIsFocused();
    const eventId = useLobbySectionSelection(state => state.eventId);

    useEffect(() => {
        if (!isFocused || !eventId) {
            return;
        }
        const timeout = setTimeout(() => {
            const { selectedTile, actions } = useLobbySectionSelection.getState();
            actions.clearEventId();
            useEventsTabsStore.getState().actions.setSelectedTab(0);
            navigate('FantasyEventsSheets', {
                eventId,
                league: selectedTile as League,
                contextKey: Date.now().toString(),
            });
        }, LOBBY_SETTLE_MS);
        return () => clearTimeout(timeout);
    }, [isFocused, eventId]);
};
